import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/legal/components/LegalInteractive.tsx");
